import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { GuestReadinessStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

interface GuestReadinessStatusFilter extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const _GuestReadinessStatusFilter: FC<GuestReadinessStatusFilter> = props => {
  const options = Object.keys(GuestReadinessStatus).map(key => ({
    value: key,
    hasFullWidth: true,
    label: GuestReadinessStatus[key as keyof typeof GuestReadinessStatus],
  }))

  return <CheckboxBasedFilter title="Guest Readiness Status" options={options} {...props} />
}

export const GuestReadinessStatusFilter = observer(_GuestReadinessStatusFilter)
